import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { useAuth } from 'utils/auth';
import { actions } from 'utils/permissions';

import styles from './need-terminal.scss';

export default function NeedTerminal() {
    const auth = useAuth();

    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                <h2>Настройте банковский терминал</h2>
                <p>Это необходимо, чтобы начать принимать платежи и оформлять подписки для ваших клиентов.</p>
                {auth.hasPermission(actions.EDIT_SETTINGS) && (
                    <div className={styles.actions}>
                        <Link to="/settings">
                            Перейти в настройки
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
};

NeedTerminal.propTypes = {
    onClick: PropTypes.func,
};
